import React from 'react';
import { Column, Grid, Row } from 'carbon-components-react';
import { PropTypes } from 'prop-types';
import { formatter } from '../../services/formatter';

export default function Thanks({
  employees,
  servers,
  lowerPrice,
  higherPrice,
  ndr,
  OnPrem,
}) {
  return (
    <Grid id="ThankYou">
      <Row>
        <Column sm={4} md={8} lg={12}>
          <h1
            style={{
              paddingTop: '100px',
              fontSize: '60px',
            }}>
            Thank you!
          </h1>
          <h2>We have received your request</h2>
          <h4 style={{ paddingTop: '24px', paddingBottom: '15px' }}>
            Request details:{' '}
          </h4>
          <p style={{ lineHeight: '1.7' }}>
            Total Workstations or Employees: <strong>{employees}</strong>
            <br />
            Total Servers in the Environment: <strong>{servers}</strong>
            <br />
            Estimated monthly cost:{' '}
            <strong>
              {`${formatter(lowerPrice)} - ${formatter(higherPrice)}`}
            </strong>
            <br />
            Include QRadar NDR: <strong>{ndr ? 'Yes' : 'No'}</strong>
            <br />
            Delivery Option: <strong>{OnPrem}</strong>
            <br />
          </p>
          <p style={{ paddingBottom: '100px' }}> </p>
        </Column>
      </Row>
    </Grid>
  );
}

Thanks.propTypes = {
  employees: PropTypes.number,
  servers: PropTypes.number,
  lowerPrice: PropTypes.number,
  higherPrice: PropTypes.number,
  ndr: PropTypes.bool,
  OnPrem: PropTypes.string,
};
